import { logout, getCurrentUser } from '../auth';

export function createHeader(): HTMLElement {
  const user = getCurrentUser();
  const isDark = document.documentElement.classList.contains('dark');
  const header = document.createElement('header');
  header.className = 'bg-card border-b border-gray-200 h-16 flex items-center justify-between px-6 sticky top-0 z-30';
  header.innerHTML = `
    <div class="flex items-center gap-3">
      <button id="sidebar-toggle" class="lg:hidden p-2 rounded-md hover:bg-gray-100">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
      </button>
      <a href="#/dashboard" class="flex items-center gap-2">
        <div class="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
        </div>
        <span class="text-lg font-bold text-primary hidden sm:inline">PropCommand</span>
      </a>
    </div>
    <div class="flex items-center gap-4">
      <button id="theme-toggle" class="p-2 rounded-lg hover:bg-gray-100 transition-colors" title="Toggle theme">
        <svg id="theme-icon-sun" class="w-5 h-5 text-gray-600 ${isDark ? '' : 'hidden'}" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
        <svg id="theme-icon-moon" class="w-5 h-5 text-gray-600 ${isDark ? 'hidden' : ''}" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>
      </button>
      <span class="text-sm text-gray-600 hidden sm:inline">${user?.name || user?.username || ''}</span>
      <button id="logout-btn" class="btn-ghost text-sm">Logout</button>
    </div>
  `;
  header.querySelector('#logout-btn')!.addEventListener('click', logout);
  header.querySelector('#theme-toggle')!.addEventListener('click', () => {
    const html = document.documentElement;
    const nowDark = html.classList.toggle('dark');
    localStorage.setItem('theme', nowDark ? 'dark' : 'light');
    header.querySelector('#theme-icon-sun')!.classList.toggle('hidden', !nowDark);
    header.querySelector('#theme-icon-moon')!.classList.toggle('hidden', nowDark);
  });
  return header;
}
